import { prependRoot } from "../../util/prependRoot.js";
import { getApiRoot } from "../../store/configureStore.js";
import axios from "axios";

const routePrefix = "/gemeente/";

const GemeenteApi = {
	getHoofdgemeenten() {
		const serviceUrl = prependRoot(routePrefix + "hoofdgemeenten", getApiRoot());
		return axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
	}
};

export default GemeenteApi;
